export default __webpack_public_path__ + "static/4 - Elektromos tűz-3854e7cf104be866ca7da3a62a5281dc.jpg";